"use client";

import { medimoQC } from "@medimo/core-api/internal/next";
import type { components } from "@medimo/core-api/internal/openapi";
import { useEffect, useState } from "react";

type PopupNotification = components["schemas"]["NotificationReadModel"];

// 種別・公開期間・ポップアップ表示フラグ・未読・アカウント作成日の判定はサーバーが
// 適用済みのため、ここでは結果をそのまま表示対象にする（再判定・再絞り込みをしない）
// freeze が true になった時点の候補で固定し、以後は再取得の結果に追従しない
// 開く直前に候補を取り直せるよう、取得日時（dataUpdatedAt）と refetch も返す
export const usePopupNotifications = ({ freeze }: { freeze: boolean }) => {
  const { data, dataUpdatedAt, refetch } = medimoQC.useQuery(
    "get",
    "/v2/notifications/popup",
  );
  const notifications = data?.notifications ?? [];

  // 表示中に候補が減っても並びが崩れないよう、表示を始めた時点の候補で固定する。
  // 表示を始めるまでは最新の候補を使い、表示待ちの間に公開終了・既読になったお知らせを出さない
  const [confirmedNotifications, setConfirmedNotifications] =
    useState<PopupNotification[]>();

  useEffect(() => {
    if (!freeze) return;
    if (confirmedNotifications) return;
    setConfirmedNotifications(notifications);
  }, [freeze, confirmedNotifications, notifications]);

  return {
    popupNotifications: confirmedNotifications ?? notifications,
    dataUpdatedAt,
    refetch,
  };
};
